module.exports = __webpack_public_path__ + "img/icon-merge.83c933d2.svg";